import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Teleport as _Teleport, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Добавить помещение")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Удалить")
const _hoisted_3 = {
  key: 1,
  class: "spaces-list"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "q-mb-none" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Помещения:")
], -1)
const _hoisted_5 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_Space = _resolveComponent("Space")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("li", null, [
      (_ctx.building?.hasOwnProperty('spaces'))
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            size: "sm",
            icon: _ctx.building.child ? "add" : "remove",
            type: "reset",
            color: "white",
            "text-color": "standard",
            class: "q-mx-sm q-mb-sm",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.askPoints(_ctx.building)), ["stop"]))
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.askPoints(_ctx.building)), ["stop"])),
        style: _normalizeStyle(!_ctx.building?.hasOwnProperty('spaces') ? 'margin-left: 65px;': '')
      }, [
        (_ctx.facilityNodesState.building === _ctx.building?.id_building)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 0,
              to: ".selectedBuilding"
            }, [
              _createVNode(_component_q_icon, {
                name: "home",
                size: "20px"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.building?.building), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_q_icon, {
          name: "home",
          size: "20px"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.building?.building) + " ", 1),
        _createVNode(_component_q_menu, {
          "touch-position": "",
          "context-menu": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, {
              dense: "",
              style: {"min-width":"100px"}
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showSpaceModal = true;})
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createVNode(_component_q_icon, { name: "add" }),
                          _hoisted_1
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.confirm = true;})
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createVNode(_component_q_icon, { name: "delete" }),
                          _hoisted_2
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_separator),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "cancel",
                          class: "q-mx-auto"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 4),
      (_ctx.building?.hasOwnProperty('spaces') && _ctx.building.child === 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.building.spaces, (space, index) => {
              return (_openBlock(), _createBlock(_component_Space, {
                key: space.id_space,
                space: space,
                buildingOrder: _ctx.buildingOrder,
                addressOrder: _ctx.addressOrder,
                addressID: _ctx.addressID,
                buildingID: _ctx.building.id_building,
                spaceOrder: index,
                cityOrder: _ctx.cityOrder,
                districtOrder: _ctx.districtOrder
              }, null, 8, ["space", "buildingOrder", "addressOrder", "addressID", "buildingID", "spaceOrder", "cityOrder", "districtOrder"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showSpaceModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showSpaceModal) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, "Добавить помещение в " + _toDisplayString(_ctx.building?.building), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_form, {
              onSubmit: _ctx.tryAddSpace,
              class: "q-gutter-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "text",
                  modelValue: _ctx.numFloors,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.numFloors) = $event)),
                  label: "Этажей"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "text",
                  modelValue: _ctx.numSpace,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.numSpace) = $event)),
                  label: "Номер помещения"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    label: "Добавить",
                    type: "submit",
                    color: "primary"
                  }),
                  _withDirectives(_createVNode(_component_q_btn, {
                    label: "Отмена",
                    color: "primary"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.confirm,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.confirm) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Отмена",
                  color: "primary"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  label: "Удалить",
                  color: "negative",
                  onClick: _ctx.removeBuilding
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}